import { render, staticRenderFns } from "./secondSceneryCateList.vue?vue&type=template&id=12024927&scoped=true&"
import script from "./secondSceneryCateList.vue?vue&type=script&lang=js&"
export * from "./secondSceneryCateList.vue?vue&type=script&lang=js&"
import style0 from "./secondSceneryCateList.vue?vue&type=style&index=0&id=12024927&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12024927",
  null
  
)

export default component.exports